import { api } from "@/lib/api";

export const TYPE_LABEL = {
  purchase: "Pembelian",
  fee: "Biaya",
  interest: "Bunga",
  installment: "Cicilan",
  payment: "Pembayaran",
  refund: "Refund",
  other: "Lainnya",
};

export const STATUS_META = {
  ready: { label: "Siap", cls: "border-[hsl(160_40%_30%)] text-[hsl(160_55%_60%)] bg-[hsl(160_40%_8%)]" },
  processing: { label: "Dianalisa AI…", cls: "border-[color:var(--hairline)] text-primary bg-[hsl(43_30%_8%)]" },
  error: { label: "Perlu tindakan", cls: "border-[hsl(0_45%_32%)] text-[hsl(0_72%_68%)] bg-[hsl(0_40%_8%)]" },
};

export const cardName = (s) =>
  s?.card_label || [s?.bank, s?.card_last4 ? `••${s.card_last4}` : ""].filter(Boolean).join(" ") || s?.filename || "Kartu";

/** Reimbursable = everything except bill payments. */
export const isReimbursable = (t) => t.type !== "payment";

export async function downloadBlob(url, filename, { inline = false } = {}) {
  const res = await api.get(url, { responseType: "blob" });
  const blobUrl = URL.createObjectURL(res.data);
  if (inline) {
    window.open(blobUrl, "_blank", "noopener");
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
    return;
  }
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 5_000);
}

export function groupBy(list, key) {
  const m = new Map();
  for (const t of list) {
    const k = t[key] || "Lainnya";
    if (!m.has(k)) m.set(k, []);
    m.get(k).push(t);
  }
  return [...m.entries()]
    .map(([name, items]) => ({ name, items, total: items.reduce((a, b) => a + (b.amount || 0), 0) }))
    .sort((a, b) => b.total - a.total);
}
